import { memo } from "react";
import { ListingSpecificationProps } from "./types";
import ListingHeader from "./components/ListingHeader";
import ListingInfoCard from "./components/ListingInfoCard";
import ListingLocationSection from "./components/ListingLocationSection";
import ListingVehicleSpecs from "./components/ListingVehicleSpecs";
import ListingAdditionalData from "./components/ListingAdditionalData";
import ListingWarranty from "./components/ListingWarranty";
import ListingEquipment from "./components/ListingEquipment";
import ListingPayment from "./components/ListingPayment";
import ListingContact from "./components/ListingContact";
import ListingVideoSection from "./components/ListingVideoSection";

// Top-level kompozit svih sekcija marketplace detail prikaza. Strukturalno
// reflektira wizard-ov MarketplaceStep (Podaci oglasa → Mogućnost plaćanja →
// Tehničke specifikacije → Ostali podaci → Lokacija → Kontakt → Oprema → Video).
const ListingSpecification: React.FC<ListingSpecificationProps> = (props) => {
  const { listing, channel, vehicle } = props;
  const details = listing.marketplaceDetails;

  return (
    <div>
      <ListingHeader listing={listing} channel={channel} />
      <ListingInfoCard listing={listing} channel={channel} />
      {/* Plaćanje ide odmah ispod opisa, isto kao u wizardu (AdDataSection). */}
      <ListingPayment details={details} />
      <ListingVehicleSpecs vehicle={vehicle} details={details} />
      <ListingAdditionalData vehicle={vehicle} details={details} />
      <ListingWarranty details={details} />
      <ListingLocationSection details={details} location={listing.location} />
      <ListingContact contacts={listing.contacts} offices={listing.offices} />
      <ListingEquipment details={details} />
      <ListingVideoSection details={details} />
    </div>
  );
};

export default memo(ListingSpecification);
